<template>
  <div 
    v-if="isMaintenanceMode" 
    class="fixed inset-0 z-80000 bg-gray-50 dark:bg-gray-950 h-screen w-screen flex items-center justify-center text-gray-700 dark:text-white"
  >
    <div class="text-center z-60 p-4">
      <img src="/images/illustrations/maintenance.png" alt="Ovatu" class="w-80 mx-auto mb-4 rounded-xl">
      <div class="text-2xl tracking-tighter font-dark font-semibold leading-tight">
        {{ title }}
      </div>
      <p class="text-lg font-light leading-normal">
        {{ content }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceOverlay',
  computed: {
    isMaintenanceMode () {
      return !!this.$store.getters.maintenance
    },
    title () {
      return this.$store.getters.maintenance?.title || 'We\'ll be right back...'
    },
    content () {
      return this.$store.getters.maintenance?.content || 'Ovatu is currently down for maintenance. We\'ll be back very soon!'
    },
  },
}
</script> 